import { getMoreLikeThis } from "../../../../fetch/graphql/requests/relatedItems/library";
import { transformForLayouts } from "../../../../utils/dataTransform/ContentQueryWidget/library";
import { transformAllContentItems } from "../../../../utils/dataTransform/library";
import log from "../../../../utils/logger/library";
import { DEFAULT_SWIMLANE_LAYOUT } from "../../../../components/LayoutFactory/constants";

export const fetchMoreLikeThis = async (
    limit,
    relatedVideoMediaId,
    path,
    layout = DEFAULT_SWIMLANE_LAYOUT,
    algorithmId = null,
    featureAttributionData = {}
) => {
    try {
        const result = await getMoreLikeThis(
            relatedVideoMediaId,
            limit,
            algorithmId
        );
        const cardContentItems = result?.data?.relatedItems?.nodes || [];
        const transformedContentItems = cardContentItems.length
            ? transformAllContentItems(cardContentItems)
            : [];
        const moreLikeThisItems = transformedContentItems.length
            ? transformForLayouts(
                  transformedContentItems,
                  layout,
                  path,
                  featureAttributionData
              )
            : [];

        return moreLikeThisItems;
    } catch (error) {
        log.error("(fetchMoreLikeThis) error fetching clips", error);
        return [];
    }
};
